<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <div class="row">
        <div class="col-xs-16">
          <h5>
            Month-By-Month Development
          </h5>
        </div>

        <div class="col-xs-4">
          <SelectWidget
              v-if="!loading"
              v-model="granularity"
              class="form-control input-sm"
              :options="[{value: 'months', label: 'Months'}, {value: 'quarters', label: 'Quarters'}, {value: 'years', label: 'Years'}]"
          />
        </div>

        <div class="col-xs-4">
          <SelectWidget
              v-if="!loading"
              v-model="selectedChannel"
              class="form-control input-sm pull-right"
              :nullable="true"
              placeholder="(all channels)"
              :options="channelOptions"
          />
        </div>
      </div>
    </div>

    <LoadingSpinner v-if="loading" :style="loadingSpinnerStyle"/>

    <div v-else class="panel-body">
      <div v-if="rows.length">
        <MonthlyChart
            :year="year"
            :portal="portal"
            :user="user"
            :channels="channels"
            :selected-channel="selectedChannel"
            :granularity="granularity"
            :target-metric="targetMetric"
            :rows="rows"
            :loading="loading"
        />

        <hr>

        <MonthlyTable
            :year="year"
            :selected-channel="selectedChannel"
            :granularity="granularity"
            :target-metric="targetMetric"
            :rows="rows"
        />
      </div>

      <div v-else class="text-center text-muted" style="margin: 22px 0">
        There is no data to display!
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import MonthlyChart from './MonthlyChart'
import MonthlyTable from './MonthlyTable'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

export default {
  components: {LoadingSpinner, MonthlyChart, MonthlyTable, SelectWidget},

  mixins: [SaveHeight],

  props: ['year', 'portal', 'targetMetric', 'user'],

  data() {
    return {
      selectedChannel: null,
      granularity: 'months',
      loading: true,
      rows: null
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    },

    targetMetric() {
      this.load()
    },

    portal() {
      this.load()
    },

    user() {
      this.load()
    },

    granularity() {
      this.load()
    }
  },

  computed: {
    channels() {
      return Object.values(
          this.rows
              .reduce((result, row) => {
                result[row.channel] = {id: row.channel, name: row.channel_name, color: row.channel_color}

                return result
              }, {})
      )
    },

    channelOptions() {
      return this.channels.map(channel => ({value: channel.id, label: channel.name}))
    },

    granularityDimension() {
      if (this.granularity === 'months') {
        return 'publish_month'
      }

      if (this.granularity === 'quarters') {
        return 'publish_quarter'
      }

      return 'publish_year'
    },

    filters() {
      return [
        {dimension: 'publish_year', operator: '=', value: this.year},
        {dimension: 'portal_id', operator: '=', value: this.portal.id}
      ]
    },

    filtersWithUser() {
      if (!this.user) {
        return this.filters
      }

      return this.filters.concat({dimension: 'user_id', operator: '=', value: this.user})
    }
  },

  methods: {
    load() {
      this.saveHeight()

      this.selectedChannel = null

      this.loading = true

      Promise.all([
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: 'ad_value_after_costs'},
          ],
          dimensions: [
            {name: this.granularityDimension},
            {name: 'channel'},
            {name: 'channel_name'},
            {name: 'channel_color'},
          ],
          filters: this.filtersWithUser
        }),
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: this.targetMetric},
          ],
          dimensions: [
            {name: this.granularityDimension},
            {name: 'channel'},
            {name: 'channel_name'},
            {name: 'channel_color'},
          ],
          filters: this.filters
        })
      ]).then(responses => {
        this.rows = responses[0].data.data.concat(responses[1].data.data)

        this.loading = false
      })
    },
  }
}
</script>
